module.exports = __webpack_public_path__ + "img/4.376d895d.jpg";